

















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class contentConsent extends Vue {
  @Prop() public consentName!: string;
}
